import { UserTableListType } from "@/types";

// 初始化状态
const initState = {
  // 列表数据
  tableInfo: {
    list: [] as UserTableListType[],
    total: 0,
  },
};

// 定义 action 类型
type Props = {
  type: "Z1/getList";
  payload: { list: UserTableListType[]; total: number };
};

// reducer
export default function userReducer(state = initState, action: Props) {
  switch (action.type) {
    // 获取列表数据
    case "Z1/getList":
      return { ...state, tableInfo: action.payload };

    default:
      return state;
  }
}
